import React from 'react';
import bannerLg from '../../../assets/images/bannertest.jpg';
import bannerSm from '../../../assets/images/banner-sm.jpg';

function Banner() {
  return (
    <section className="relative h-[100svh] min-h-[560px] w-full overflow-hidden">
      {/* Background image */}
      <picture>
        <source media="(max-width: 768px)" srcSet={bannerSm} />
        <img
          src={bannerLg}
          alt="Iluminación Fabrilum"
          className="absolute inset-0 h-full w-full scale-105 animate-fade-in object-cover"
        />
      </picture>

      {/* Gradient overlays for legibility + warmth */}
      <div className="absolute inset-0 bg-gradient-to-t from-ink/85 via-ink/30 to-ink/40" />
      <div className="absolute inset-0 bg-gradient-to-r from-ink/60 to-transparent" />

      {/* Content */}
      <div className="relative z-10 mx-auto flex h-full max-w-7xl flex-col justify-end px-6 pb-24 md:px-10 md:pb-32">
        <div className="max-w-2xl">
          <p className="mb-5 inline-flex animate-fade-up items-center gap-3 text-xs font-medium uppercase tracking-wider2 text-brand-300">
            <span className="h-px w-10 bg-brand-300" />
            Fábrica de iluminación · Córdoba, Argentina
          </p>
          <h1
            className="animate-fade-up font-display text-5xl font-medium leading-[1.05] text-white sm:text-6xl md:text-7xl"
            style={{ animationDelay: '0.1s' }}
          >
            Diseñamos
            <br />
            <span className="italic text-brand-300">la luz</span> que habita
            <br />
            tus espacios
          </h1>
          <p
            className="mt-6 max-w-lg animate-fade-up text-base font-light leading-relaxed text-white/80 md:text-lg"
            style={{ animationDelay: '0.2s' }}
          >
            Más de 10 años fabricando luminarias de diseño en Argentina.
            Calidad, terminaciones impecables y producción nacional.
          </p>
          <div
            className="mt-9 flex animate-fade-up flex-wrap items-center gap-4"
            style={{ animationDelay: '0.3s' }}
          >
            <a href="/productos" className="btn-primary bg-white text-ink hover:bg-brand-400 hover:text-ink">
              Ver productos
              <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M13 6l6 6-6 6" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </a>
            <a
              href="#nosotros"
              className="inline-flex items-center justify-center gap-2 rounded-full border border-white/40 px-7 py-3 text-sm font-medium tracking-wide text-white transition-all duration-300 hover:bg-white hover:text-ink"
            >
              Conocé Fabrilum
            </a>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 z-10 hidden -translate-x-1/2 flex-col items-center gap-2 text-white/60 md:flex">
        <span className="text-[10px] uppercase tracking-wider2">Scroll</span>
        <span className="flex h-9 w-5 items-start justify-center rounded-full border border-white/40 p-1">
          <span className="h-2 w-1 animate-float rounded-full bg-white/70" />
        </span>
      </div>
    </section>
  );
}

export default Banner;
